import "@babel/polyfill";
import "details-polyfill";
import React from "react";
import { hydrate } from "react-dom";
import {
  updateStateWithClientData,
  ModalContentContainer,
  MainContentContainer
} from "./Root";
import startCheckSameSiteIframe from "./sameSiteCookie";
import "./reactAxe";
import { asosGlobalNamespace } from "../template/constants";

import {
  logCookieDataAsCustomAttributes,
  logCookieDataAsPageAction
} from "./cookieAnalysis";

window.addEventListener("load", logCookieDataAsCustomAttributes);

window[asosGlobalNamespace].eventBus.addListener(
  "sdk-ready",
  logCookieDataAsPageAction
);

document.addEventListener("DOMContentLoaded", function() {
  const modalContentElement = document.getElementById("chrome-modal-content");
  const mainContentElement = document.getElementById("chrome-main-content");
  hydrate(<MainContentContainer />, mainContentElement);
  hydrate(<ModalContentContainer />, modalContentElement);

  window[asosGlobalNamespace].eventBus.emit("hydrate-ready");
  updateStateWithClientData();
});

startCheckSameSiteIframe();
